import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export var DriveRequest = /*#__PURE__*/function () {
  function DriveRequest(params) {
    _classCallCheck(this, DriveRequest);
    /** 入参 */
    _defineProperty(this, "params", void 0);
    /** 数据源对应接口的参数 */
    _defineProperty(this, "payload", void 0);
    /** 数据源的返回值 */
    _defineProperty(this, "response", void 0);
    this.params = params;
    this.payload = null;
    this.response = null;
  }

  /**
   * 以当前的入参向指定数据源请求数据
   */
  _createClass(DriveRequest, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.payload = null;
              this.response = null;
              this.payload = this.getPayload(this.params);
              _context.next = 5;
              return this.request(this.payload);
            case 5:
              this.response = _context.sent;
              return _context.abrupt("return", this.getResult(this.response));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function send() {
        return _send.apply(this, arguments);
      }
      return send;
    }()
    /**
     * 可根据不同数据源定制的 request 方法
     * @param payload
     */
  }]);
  return DriveRequest;
}();
//# sourceMappingURL=drive-request.js.map